import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LocalStorageService {
    get(key: string): unknown {
        const item = localStorage.getItem(key);
        if (!item || item === 'null') {
            return null;
        }

        try {
            return JSON.parse(item);
        } catch {
            return null;
        }
    }

    set(key: string, value: unknown): boolean {
        try {
            localStorage.setItem(key, JSON.stringify(value));
            return true;
        } catch {
            return false;
        }
    }

    remove(key: string): boolean {
        try {
            localStorage.removeItem(key);
            return true;
        } catch {
            return false;
        }
    }
}
